import { useTranslation } from 'libs/i18n';
import {
  DocumentsTableFeature,
  DocumentsTableFeatureProps,
} from 'modules/client/common/feature';

interface Props
  extends Pick<
    DocumentsTableFeatureProps,
    'readOnly' | 'title' | 'titleVariant'
  > {}

export const DocumentsSection = ({ title, readOnly, titleVariant }: Props) => {
  const { t } = useTranslation();
  return (
    <DocumentsTableFeature
      datax="documentsSection"
      name="documentsFiles"
      readOnly={readOnly}
      title={title ?? t('client.documentsSection.title')}
      titleVariant={titleVariant}
    />
  );
};
